import { Button, DataSource, Label, Layout, Panel, PortalLocation, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFreightCalculator extends Layout {
    blankSpace: Panel;
    buttonSendRateRequest: Button;
    errorBox: Textbox;
    estimatedLinehaul: Textbox;
    fuelRate: Textbox;
    fuelsurcharge: Textbox;
    labelLabel1: Label;
    labelLabel2: Label;
    labelfs: Label;
    labellinehaul: Label;
    labelsplitter: Label;
    labeltotal: Label;
    linehaulRate: Textbox;
    location2: PortalLocation;
    location: PortalLocation;
    orderType: Textbox;
    panelFreightCalculator: Panel;
    pickupDate: Textbox;
    rateButton: Button;
    rateMethod: Textbox;
    ratingResultsPanel: Panel;
    sourceDestCity: DataSource;
    sourceDestLocation: DataSource;
    sourceLocation: DataSource;
    sourceOrderStop: DataSource;
    sourceOrders: DataSource;
    sourceOriginCity: DataSource;
    sourceOriginLocation: DataSource;
    totalcharge: Textbox;
    weight: Textbox;
    weightCharged: Textbox;
}
